import React from "react";
import { Col, Row } from "reactstrap";
import "./index.scss";
import PacketStatBox from "./PacketStatBox";
const PacketStatsBlock = () => {
	return (
		<>
			<div className="packet-stats-blc">
				<Col>
					<Row>
						<Col lg="4">
							<PacketStatBox
								label="PACKETS IN MANUAL REVIEW"
								value="3"
								iconColor="bg1"
							/>
						</Col>
						<Col lg="4">
							<PacketStatBox
								label="AVG. DAILY VOLUME CHANGE"
								value="12.5%"
								iconColor="bg2"
							/>
						</Col>
						<Col lg="4">
							<PacketStatBox
								label="FTES Automated"
								value="6"
								iconColor="bg3"
							/>
						</Col>
					</Row>
				</Col>
			</div>
		</>
	);

}
export default PacketStatsBlock;